import { MouseState } from '../../../cross-team-shared/state/mouse-state';
import { Point2D } from '../../../team-apis/otterdam/answers/shape-typings';

export class MouseState2D extends MouseState {
  clientPoint: Point2D = [0, 0];
  imagePoint: Point2D = [0, 0];
}
